__webpack_require__.p = "/wp-content/themes/sogeti2024/public/dist/";